import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-678cfa6a")

_pushScopeId("data-v-678cfa6a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Anagrafiche")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "container_anagrafiche" }
const _hoisted_5 = { class: "anagrafica_switcher" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "no_clienti_container"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "no_clienti" }, "Nessun cliente da visualizzare", -1)
const _hoisted_9 = { class: "cliente_info" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = {
  key: 0,
  class: "address"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "cliente_info" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = {
  key: 0,
  class: "address"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "cliente_info" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = {
  key: 0,
  class: "address"
}
const _hoisted_20 = {
  key: 1,
  class: "address"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "Email:", -1)
const _hoisted_22 = {
  key: 2,
  class: "address"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, "Cellulare:", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadClienti()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading || $setup.loadingContatti || $setup.loadingFornitori)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.modeSwitcher, (mode, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        class: ["type", [$setup.selectedAnagraficaType == mode.mode_id ? 'active' : '']],
                        onClick: ($event: any) => ($setup.setActiveAnagrafica(`${mode.mode_id}`))
                      }, _toDisplayString(mode.mode_label), 11, ["onClick"]))
                    }), 128))
                  ]),
                  ($setup.showClienti)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode("div", {
                          class: "nuovo_cliente_button",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openNewCustomer && $setup.openNewCustomer(...args)))
                        }, "Nuovo cliente"),
                        ($setup.clienti.length == 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_7, [
                              _hoisted_8
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", null, [
                          _createVNode(_component_ion_input, {
                            type: "text",
                            "clear-input": "",
                            modelValue: $setup.searchQuery,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.searchQuery = $event)),
                            placeholder: "Ricerca cliente",
                            class: "search_customers"
                          }, null, 8, ["modelValue"])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.searchedCustomers, (cliente) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "cliente",
                            key: cliente.customers_id,
                            onClick: ($event: any) => ($setup.openDetailModal(cliente))
                          }, [
                            _createVNode("div", _hoisted_9, [
                              _createVNode("div", _hoisted_10, _toDisplayString($setup.riferimentoCliente(cliente)), 1),
                              (cliente.customers_city)
                                ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString($setup.indirizzoAnagrafica(cliente)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, ["onClick"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.showFornitori)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _createVNode("div", null, [
                          _createVNode(_component_ion_input, {
                            type: "text",
                            "clear-input": "",
                            modelValue: $setup.searchQueryFornitori,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.searchQueryFornitori = $event)),
                            placeholder: "Ricerca fornitore",
                            class: "search_customers"
                          }, null, 8, ["modelValue"])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.searchedFornitori, (fornitore) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "cliente",
                            key: fornitore.customers_id,
                            onClick: ($event: any) => ($setup.openDetailModal(fornitore))
                          }, [
                            _createVNode("div", _hoisted_13, [
                              _createVNode("div", _hoisted_14, _toDisplayString($setup.riferimentoCliente(fornitore)), 1),
                              (fornitore.customers_city)
                                ? (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString($setup.indirizzoAnagrafica(fornitore)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, ["onClick"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.showContatti)
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _createVNode("div", null, [
                          _createVNode(_component_ion_input, {
                            type: "text",
                            "clear-input": "",
                            modelValue: $setup.searchQueryContatti,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.searchQueryContatti = $event)),
                            placeholder: "Ricerca contatto",
                            class: "search_customers"
                          }, null, 8, ["modelValue"])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.searchedContatti, (contatto) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "cliente",
                            key: contatto.customers_id
                          }, [
                            _createVNode("div", _hoisted_17, [
                              _createVNode("div", _hoisted_18, _toDisplayString($setup.riferimentoContatto(contatto)), 1),
                              (contatto.customers_full_name)
                                ? (_openBlock(), _createBlock("div", _hoisted_19, "Cliente: " + _toDisplayString(contatto.customers_full_name), 1))
                                : _createCommentVNode("", true),
                              (contatto.customers_contacts_email)
                                ? (_openBlock(), _createBlock("div", _hoisted_20, [
                                    _hoisted_21,
                                    _createVNode("a", {
                                      href: `mailto:${contatto.customers_contacts_email}`,
                                      target: "_blank",
                                      class: "mobile_link"
                                    }, _toDisplayString(contatto.customers_contacts_email), 9, ["href"])
                                  ]))
                                : _createCommentVNode("", true),
                              (contatto.customers_contacts_mobile_number )
                                ? (_openBlock(), _createBlock("div", _hoisted_22, [
                                    _hoisted_23,
                                    _createVNode("a", {
                                      href: `tel:${contatto.customers_contacts_mobile_number}`,
                                      target: "_blank",
                                      class: "mobile_link"
                                    }, _toDisplayString(contatto.customers_contacts_mobile_number), 9, ["href"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})